const {
    isFinalLoginResponse,
    isMfaChallengeResponse,
} = require('../../services/mfaLoginResponse');

function isMfaLoginHandoff(search) {
    const params = new URLSearchParams(search || '');
    return Boolean(params.get('mfaToken') || params.get('mfaError') === 'true');
}

function isMfaSetupActionDisabled({ loading, status }) {
    return Boolean(loading || !status?.canEnable);
}

function normalizeMfaCode(code) {
    return String(code || '')
        .replace(/\D/g, '')
        .slice(0, 6);
}

function isMfaLoginActionDisabled({ loading, code }) {
    return Boolean(loading || normalizeMfaCode(code).length !== 6);
}

function buildMfaVerifyPayload(challenge, code) {
    return {
        token: challenge.mfa.token,
        code: normalizeMfaCode(code),
    };
}

function getMfaTokenFromSearch(search) {
    const params = new URLSearchParams(search || '');
    return params.get('mfaToken');
}

function buildSearchAfterMfaTokenError(search) {
    const params = new URLSearchParams(search || '');
    params.delete('mfaToken');
    params.set('mfaError', 'true');

    if (!params.has('byPassSSO')) {
        params.set('byPassSSO', 'true');
    }

    const query = params.toString();
    return query ? `?${query}` : '';
}

function getMfaTokenErrorMessage(search, tokenErrorMessage) {
    const params = new URLSearchParams(search || '');
    return params.get('mfaError') === 'true' ? tokenErrorMessage : '';
}

function hasMfaTokenError(search) {
    const params = new URLSearchParams(search || '');
    return params.get('mfaError') === 'true';
}

function getMfaErrorMessage(error, fallbackMessage) {
    return error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : fallbackMessage;
}

function shouldRedirectAfterLogin({
    redirect,
    hasTokenParam,
    hasMenuData,
    hasMfaTokenParam,
    hasMfaTokenErrorParam,
}) {
    return Boolean(
        redirect &&
        !hasTokenParam &&
        (!hasMenuData || hasMfaTokenParam || hasMfaTokenErrorParam)
    );
}

module.exports = {
    buildSearchAfterMfaTokenError,
    buildMfaVerifyPayload,
    getMfaErrorMessage,
    getMfaTokenFromSearch,
    getMfaTokenErrorMessage,
    hasMfaTokenError,
    isFinalLoginResponse,
    isMfaChallengeResponse,
    isMfaLoginActionDisabled,
    isMfaLoginHandoff,
    isMfaSetupActionDisabled,
    normalizeMfaCode,
    shouldRedirectAfterLogin,
};
